import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Box, Typography, Button } from '@mui/material';
import { useUrlContext } from '../context/urlContext';
import ParentComponent from '../Components/ParentForTableAndFormComponent';
import PartnerForm from '../Forms/PartnerForm';
import { errorContext } from '../Components/ErrorDisplay';
import { useConfirm } from '../Components/ConfirmDialog';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/authContext';

function ClubManagement() {
  const { UrlHelperObj } = useUrlContext();
  const { handleError, setErrorMessage } = useContext(errorContext);
  const confirm = useConfirm();
  const { setSelectedClub, clearSelectedClub } = useAuth();
  const history = useHistory();
  const [clubRecords, setClubRecords] = useState([]);
  const [selectedClub, setSelectedClubRow] = useState(null);
  const [formShown, setFormShown] = useState(false);
  const [columnInfo] = useState([
    { title: 'Name', dbname: 'name' },
    { title: 'Key Contact', dbname: 'key_contacts' },
    { title: 'Logo', dbname: 'logo' },
  ]);

  async function getClubRecords() {
    await axios.get(UrlHelperObj.partnerUrl())
      .then(response => response.data)
      .then(results => setClubRecords(results))
      .catch(err => handleError(err));
  }

  useEffect(() => {
    getClubRecords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (formShown && !selectedClub) {
      clearSelectedClub();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formShown, selectedClub]);

  function handleNext() {
    if (!selectedClub) {
      setErrorMessage('Please select a club first.');
      return;
    }

    setErrorMessage(null);
    setSelectedClub(selectedClub);
    history.push('/club/' + selectedClub.id + '/home', { club: selectedClub });
  }

  async function deleteClubRecord(record) {
    const ok = await confirm({ title: 'Delete club', message: 'Are you sure you want to delete this club?', confirmText: 'Delete' });
    if (!ok) {
      return;
    }
    const id = record.id ? record.id : record;
    await axios.delete(UrlHelperObj.partnerUrlById(id))
      .then(response => response.data)
      .then(results => console.log("delete of Partner successful"))
      .catch(err => handleError(err));
    getClubRecords();
  }

  async function editClubRecord(record) {
    const data = new FormData();
    data.append("id", record.id);
    data.append("name", record.partnerName);
    data.append("key_contacts", record.contact);
    data.append("timezone", record.timezone);
    data.append("mypreorderid", record.mypreorderid);
    data.append("entrykey", record.entrykey || '');
    data.append("expiry_date", record.expiry_date || '');
    if (record.logo instanceof File) {
      data.append("image", record.logo, record.logo.name);
    }

    console.log("Submitting Club Edit Payload:", record);
    await axios.put(UrlHelperObj.partnerUrl(), data)
      .then(response => response.data)
      .then(results => console.log("Edit of Partner successful"))
      .catch(err => handleError(err));
    getClubRecords();
  }

  async function addClubRecord(record) {
    const data = new FormData();
    data.append("name", record.partnerName);
    data.append("key_contacts", record.contact);
    data.append("timezone", record.timezone);
    data.append("mypreorderid", record.mypreorderid);
    data.append("entrykey", record.entrykey || '');
    data.append("expiry_date", record.expiry_date || '');
    // "Copy as redemption partner" checkbox (add-only). true/false.
    data.append("rpFlag", record.rpFlag ? true : false);
    if (record.logo instanceof File) {
      data.append("image", record.logo, record.logo.name);
    }

    console.log("Submitting Club Add Payload:", record);
    await axios.post(UrlHelperObj.partnerUrl(), data)
      .then(response => response.data)
      .then(results => console.log("Add of Partner successful"))
      .catch(err => handleError(err));
    getClubRecords();
  }

  function handleFormSubmit(data, isAddOperation, isCancelOperation) {
    setFormShown(false);
    if (isCancelOperation) {
      return;
    }
    if (isAddOperation) {
      addClubRecord(data);
    } else {
      editClubRecord(data);
    }
  }

  return (
    <Box style={{ padding: 16 }}>
      <Typography variant="h5" style={{ textAlign: 'left', marginBottom: 12 }}>
        Club / Issuing Partner Management
      </Typography>
      <ParentComponent
        data={clubRecords}
        columns={columnInfo}
        form={PartnerForm}
        formTitle={"Club"}
        hideFormTitle={true}
        setFormShownFlag={setFormShown}
        handleFormSubmitFunc={handleFormSubmit}
        deleteFunc={deleteClubRecord}
        setSelectedRow={setSelectedClubRow}
        alreadySelectedOwnRow={selectedClub}
      />
      {!formShown && (
      <Box style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 12 }}>
        <Button variant="contained" color="primary" onClick={handleNext} disabled={!selectedClub}
          sx={{ '&.Mui-disabled': { backgroundColor: '#bdbdbd !important', color: '#757575 !important', boxShadow: 'none' } }}>
          Select
        </Button>
      </Box>
      )}
    </Box>
  );
}

export default ClubManagement;